import { createContext, type ReactNode, useMemo } from 'react';

import type { Dictionary } from 'dictionary';
import { useLocale, useRequiredContext } from 'hooks';

import { I18n } from './I18n';

const I18nContext = createContext<I18n | undefined>(undefined);

interface ProviderProps {
	children: ReactNode;
	dictionary: Dictionary | undefined;
}

export function I18nProvider({ children, dictionary }: ProviderProps) {
	const { locale } = useLocale();
	const value = useMemo(
		() => new I18n(dictionary ?? {}, locale),
		[dictionary, locale],
	);
	return <I18nContext value={value}>{children}</I18nContext>;
}
I18nProvider.displayName = 'I18nProvider';

export function useI18n() {
	return useRequiredContext(I18nContext, 'I18nContext');
}
